import { endpoints } from "./../../data/endpoints"
import { requestThunk } from "./serverThunks"
import { ThunkAction } from "redux-thunk"
import { StoreState } from "../StoreState"
import { AnyAction } from "redux"
import { IPublicHealthStatusDto } from "../../type/healthStatusTypes"
import { healthStatusReducerActions, healthStatusSelectors } from "../reducers/healthStatusReducer "

export const ensureHealthStatusesThunk =
    (force?: boolean): ThunkAction<Promise<void>, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        if (!force && healthStatusSelectors.healthStatuses(getState())) {
            return
        }
        const res = await dispatch(
            requestThunk<{ healthStatuses: IPublicHealthStatusDto[] }>(endpoints.PaymentsJobs.getHealthStatus)
        )
        dispatch(healthStatusReducerActions.setHealthStatuses(res.healthStatuses))
    }
